<template>
  <div @click="buttonClicked">
    <input ref="fileInput" type="file" style="display:none" @change="fileChange">
    <p >{{btnText}}</p>
  </div>
</template>

<script>
export default {
  props: {
    btnText: String,
  },
  methods: {
    buttonClicked() {
      console.log('upload button click');
      this.$refs.fileInput.click();
    },
    fileChange() {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target.result.length > 0) {
          const result = JSON.parse(event.target.result);
          this.$emit('fileChange', result);
          this.$refs.fileInput.value = null;
        }
      };
      reader.readAsText(this.$refs.fileInput.files[0]);
    },
  },
};
</script>

<style scoped>
p{
  margin-bottom: 0;
}
</style>
